<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :ripple="false" icon>
        <v-icon small>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="visualize(serviceProviderUser.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-eye-outline </v-icon>
        <span class="body-2">{{ $t('forms.visualize') }}</span>
      </v-list-item>
      <v-list-item @click="edit(serviceProviderUser.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-pencil-outline </v-icon>
        <span class="body-2">{{ $t('forms.update') }}</span>
      </v-list-item>
      <v-list-item @click="remove(serviceProviderUser.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-delete-outline </v-icon>
        <span class="body-2">{{ $t('forms.delete') }}</span>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'ServiceProviderListMenu',

  props: {
    serviceProviderUser: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions(['openModal', 'showServiceProviderUser']),
    ...mapMutations(['setIsDrawerOpen']),

    visualize(id) {
      this.setIsDrawerOpen(true)
      this.showServiceProviderUser(id)
    },

    edit(id) {
      this.openModal('CREATE_UPDATE_SERVICE_PROVIDER_USER')
      this.showServiceProviderUser(id)
    },

    remove(id) {
      this.openModal('REMOVE_SERVICE_PROVIDER_USER')
      this.showServiceProviderUser(id)
    },
  },
}
</script>
